import { ProcessesIndexRoute } from "@/routes/processes/processes-route";
import HTZRoute from "@/routes/processes/[processId]/htz/htz-route";
import { htzRoutes } from "@/routes/processes/[processId]/htz/htz-routes";
import RLTRoute from "@/routes/processes/[processId]/rlt/rlt";
import { rltRoutes } from "@/routes/processes/[processId]/rlt/rlt-routes";
import VBSRoute from "@/routes/processes/[processId]/vbs/vbs";
import { vbsRoutes } from "@/routes/processes/[processId]/vbs/vbs-routes";
import QPMRoute from "@/routes/processes/[processId]/qpm/qpm-route";
import { qpmRoutes } from "@/routes/processes/[processId]/qpm/qpm-routes";
import GFSRoute from "@/routes/processes/[processId]/gfs/gfs-route";
import { gfsRoutes } from "@/routes/processes/[processId]/gfs/gfs-routes";

export const processesRoutes = [
  {
    index: true,
    element: <ProcessesIndexRoute />,
  },
  {
    path: "htz/:processId",
    element: <HTZRoute />,
    children: htzRoutes,
  },
  {
    path: "rlt/:processId",
    element: <RLTRoute />,
    children: rltRoutes,
  },
  {
    path: "vbs/:processId",
    element: <VBSRoute />,
    children: vbsRoutes,
  },
  {
    path: "gfs/:processId",
    element: <GFSRoute />,
    children: gfsRoutes,
  },
  {
    path: "qpm/:processId",
    element: <QPMRoute />,
    children: qpmRoutes,
  },
];
